import {useContext} from "react";
import {NotificationContext} from "v4/contexts/NotificationContext";

export default function useNotification() {

    return useContext(NotificationContext);
}
